import { render } from "./ReservationInput.vue?vue&type=template&id=081c87ea"
import script from "./ReservationInput.vue?vue&type=script&lang=js"
export * from "./ReservationInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__